import {Component, OnDestroy, OnInit} from '@angular/core';

@Component({
  selector: 'app-help-menu',
  templateUrl: './help-menu.component.html',
  styleUrls: ['./help-menu.component.scss']
})
export class HelpMenuComponent implements OnInit, OnDestroy {
  public supportMail: String = 'support@commandersact.com';

  constructor() {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  public showConsentManagement(): void {
    if (window && window['tC'] && window['tC'].privacyCenter ) {
      window['tC'].privacyCenter.showPrivacyCenter();
    }
  }
}
